import * as React from "react";
import Svg, { G, Rect, Path, Defs, ClipPath } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={44}
    height={44}
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <G clipPath="url(#clip0_6682_20360)">
      <Rect width={44} height={44} fill={props.bgColor || "#EBF2FF"} />
      <G clipPath="url(#clip1_6682_20360)">
        <Path
          d="M11.7891 18.856H32.2176L22.0033 12.5703L11.7891 18.856Z"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M14.9297 18.8594V26.7165"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M19.6406 18.8594V26.7165"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M24.3594 18.8594V26.7165"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M29.0742 18.8594V26.7165"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M12.5742 26.7188H31.4314"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <Path
          d="M11 29.8594H33"
          stroke={props.color || "#2D57D9"}
          strokeWidth={1.57143}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="clip0_6682_20360">
        <Rect width={44} height={44} rx={6.28571} fill={props.bgColor || "white"} />
      </ClipPath>
      <ClipPath id="clip1_6682_20360">
        <Rect
          width={25.1429}
          height={25.1429}
          fill={props.bgColor || "white"}
          transform="translate(9.42969 9.42969)"
        />
      </ClipPath>
    </Defs>
  </Svg>
);
export default SVGComponent;
